import { Likelihood } from "@/models/labels";

export interface Insight {
  key: string;
  title: string;
  associated_heatmap: any;
  value: any;
  type: InsightType;
  controller: any;
  likelihood?: Likelihood;
  suffix?: string;
  icon?: any;
  isVs?: boolean;
  legend?: [string, string];
  message?: string;
  is_ai_finding?: boolean;
}

export enum InsightType {
  THRESHOLDED = "thresholded",
  RANGE = "range",
  SCALAR = "scalar",
}
